import { loggedInUser } from 'hooks/use-logged-in-user';
import { useTaskService } from 'hooks/services/use-task-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskLookupType } from 'types';

interface TaskClosedReasonsCache {
  closedReasons: ITaskLookupType[];
  isClosedReasonsLoading: boolean;
  hasClosedReasons: boolean;
}

export const useTaskClosedReasonsCache = (): TaskClosedReasonsCache => {
  const taskService = useTaskService();
  const { isLoggedIn } = loggedInUser.useController();

  const query = useQuery({
    queryKey: ['closedReasons'],
    queryFn: () => taskService.getTaskClosedReason(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isClosedReasonsLoading, data: closedReasons = [] } = query;

  return {
    isClosedReasonsLoading,
    closedReasons,
    hasClosedReasons: closedReasons.length > 0
  };
};
